import { fmtCLP } from "../../utils/formato";
import "./OrderSummary.css";

export default function OrderSummary({
  pedido,
  subtotal,
  totalFinal,
  descuento,
  onConfigureDescuento,
  onEliminarItem,
  onEditarCambios,
  onEnviarPedido,
  onGuardarBorrador,
  horaRetiro,
  medioPago,
  pagoDisplay,
  saldoPendiente = 0,
  pagado,
  observacion,
  enviando,
  guardandoBorrador,
  cajaAbierta,
  onOpenTabletForm,
  trabajador = false,
}) {
  const items = pedido ?? [];

  return (
    <div className="col-summary os-card">
      {cajaAbierta === false && (
        <div className="os-locked">
          <span className="os-locked__icon">!</span>
          <span className="os-locked__text">Inicia la caja para registrar pedidos</span>
        </div>
      )}

      <div className="os-header">
        <div className="os-header__left">
          <div className="os-header__icon">#</div>
          <h3 className="os-header__title">Resumen del pedido</h3>
        </div>
        <button
          type="button"
          className="os-btn-discount"
          onClick={onConfigureDescuento}
          title="Agregar/editar descuento"
        >
          Descuento
        </button>
      </div>

      <button
        type="button"
        className="os-btn-datos"
        onClick={onOpenTabletForm}
      >
        <span>Datos del pedido</span>
        {pagoDisplay && <span className="os-btn-datos__tag">{pagoDisplay}</span>}
      </button>

      {items.length === 0 ? (
        <div className="os-empty">No hay productos aun</div>
      ) : (
        <ul className="os-list">
          {items.map((it) => {
            const cambios = String(it.cambios || "").split(/\r?\n/).map((m) => m.trim()).filter(Boolean);
            return (
              <li key={`${it.producto_id}-${it.nombre}`} className="os-item">
                <div className="os-item__main">
                  <div className="os-item__name">{it.nombre}</div>
                  <div className="os-item__sub">
                    x{it.cantidad} - {fmtCLP(Number(it.precio) * Number(it.cantidad))}
                  </div>
                  {cambios.length > 0 && (
                    <div className="os-item__mods-wrap">
                      <div className="os-item__mods-title">Cambios:</div>
                      <ul className="os-item__mods">
                        {cambios.map((m, idx) => (
                          <li key={`${m}-${idx}`}>{m}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="os-item__actions">
                  <button
                    type="button"
                    className="os-item__mod"
                    title="Editar cambios"
                    onClick={() => onEditarCambios?.(it.producto_id, it.nombre)}
                    disabled={enviando}
                  >
                    Cambios
                  </button>
                  <button
                    className="os-item__remove"
                    title="Quitar uno"
                    onClick={() => onEliminarItem(it.producto_id, it.nombre)}
                    disabled={enviando}
                    aria-label="Quitar uno"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        fill="currentColor"
                        d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.9a1 1 0 0 0 1.41-1.41L13.41 12l4.9-4.89a1 1 0 0 0-.01-1.4Z"
                      />
                    </svg>
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      )}

      {items.length > 0 && (
        <div className="os-totals">
          <div className="os-totals__row">
            <span>Subtotal</span>
            <strong>{fmtCLP(subtotal)}</strong>
          </div>

          {Number(descuento) > 0 && (
            <div className="os-totals__row os-totals__row--discount">
              <span>Descuento</span>
              <strong>-{fmtCLP(descuento)}</strong>
            </div>
          )}

          <div className="os-totals__row os-totals__row--total">
            <span>Total</span>
            <strong>{fmtCLP(totalFinal)}</strong>
          </div>

          <div className="os-totals__row">
            <span>Retiro</span>
            <strong>{horaRetiro || "No definido"}</strong>
          </div>

          {trabajador ? (
            <div className="os-totals__row">
              <span>Tipo</span>
              <strong>Trabajador</strong>
            </div>
          ) : (
            <>
              <div className="os-totals__row">
                <span>Pago</span>
                <strong>{medioPago || "-"}</strong>
              </div>
              <div className="os-totals__row">
                <span>Pagado</span>
                <strong>{pagado ? "Si" : "No"}</strong>
              </div>
            </>
          )}

          {Number(saldoPendiente) > 0 && (
            <div className="os-totals__row os-totals__row--discount">
              <span>Saldo pendiente</span>
              <strong>{fmtCLP(saldoPendiente)}</strong>
            </div>
          )}

          {observacion && (
            <div className="os-totals__obs">
              <span>Obs.</span>
              <em>{observacion}</em>
            </div>
          )}
        </div>
      )}

      <div className="os-footer">
        <button
          className="os-btn-draft"
          onClick={onGuardarBorrador}
          disabled={enviando || guardandoBorrador || items.length === 0}
        >
          {guardandoBorrador ? "Guardando..." : "Guardar borrador"}
        </button>
        <button
          className="os-btn-send"
          onClick={onEnviarPedido}
          disabled={enviando || guardandoBorrador || cajaAbierta === false || items.length === 0}
        >
          {enviando ? "Enviando..." : "Enviar pedido"}
        </button>
      </div>
    </div>
  );
}
